import { get } from '@core/api/baseApi';
import { GetTemplateTagResponse } from '@core/types';

export const getTemplateTags = (filters: {Page: string, Search: string}): Promise<GetTemplateTagResponse> => get('/TemplateTags', {
    params: filters
});
